export const version = 'berater-v1.19.0-SNAPSHOT-1dd5ab74deac4073d47fa4e1eb123a91ce3b0afb';